export default "__VITE_ASSET__Dqn6Zmxt__"